var _path, _path2, _path3, _path4, _path5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExploits = function SvgExploits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 54,
    fill: "none",
    viewBox: "0 0 56 54"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 43.706,
    height: 44.674,
    x: 12.195,
    y: 0.269
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#exploits_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#exploits_svg__b)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits_svg__c)",
    fillOpacity: 0.2,
    d: "M19.762 20.054c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.958 2.223-1.6 4.791-2.884l1.486-.743c2.099-1.05 3.148-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.249 1.78l1.486.743c2.568 1.284 3.852 1.926 4.79 2.884a8 8 0 0 1 1.848 2.99c.437 1.267.437 2.703.437 5.575v1.32c0 2.873 0 4.308-.437 5.576a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-1.486.742c-2.1 1.05-3.149 1.575-4.25 1.781a8 8 0 0 1-2.95 0c-1.1-.206-2.15-.731-4.249-1.78l-1.486-.743c-2.568-1.285-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.268-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits_svg__d)",
    d: "M19.762 20.054c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.958 2.223-1.6 4.791-2.884l1.486-.743c2.099-1.05 3.148-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.249 1.78l1.486.743c2.568 1.284 3.852 1.926 4.79 2.884a8 8 0 0 1 1.848 2.99c.437 1.267.437 2.703.437 5.575v1.32c0 2.873 0 4.308-.437 5.576a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-1.486.742c-2.1 1.05-3.149 1.575-4.25 1.781a8 8 0 0 1-2.95 0c-1.1-.206-2.15-.731-4.249-1.78l-1.486-.743c-2.568-1.285-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.268-.437-2.703-.437-5.575z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.714,
    d: "M32.638 6.433a7.7 7.7 0 0 1 2.819 0c1.04.195 2.038.69 4.155 1.749l1.486.743c2.591 1.295 3.809 1.91 4.695 2.814a7.64 7.64 0 0 1 1.766 2.856c.413 1.197.417 2.561.417 5.459v1.321c0 2.898-.004 4.262-.417 5.459a7.65 7.65 0 0 1-1.766 2.855c-.886.905-2.104 1.52-4.695 2.815l-1.486.743c-2.117 1.059-3.115 1.554-4.155 1.75a7.7 7.7 0 0 1-2.82 0c-1.04-.196-2.037-.691-4.155-1.75l-1.485-.743c-2.591-1.296-3.809-1.91-4.695-2.814a7.65 7.65 0 0 1-1.766-2.856c-.413-1.197-.417-2.561-.417-5.459v-1.321c0-2.898.004-4.262.417-5.46a7.64 7.64 0 0 1 1.766-2.855c.886-.905 2.104-1.519 4.695-2.814l1.485-.743c2.118-1.059 3.116-1.554 4.156-1.75Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 43.706,
    height: 44.674,
    x: 6.481,
    y: 4.555
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#exploits_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#exploits_svg__f)",
    shapeRendering: "crispEdges"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits_svg__g)",
    fillOpacity: 0.5,
    d: "M14.048 24.34c0-2.872 0-4.308.437-5.576a8 8 0 0 1 1.847-2.989c.938-.958 2.223-1.6 4.791-2.884l1.486-.743c2.099-1.05 3.148-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.249 1.78l1.485.743c2.569 1.284 3.853 1.926 4.791 2.884a8 8 0 0 1 1.848 2.99c.437 1.267.437 2.703.437 5.574v1.322c0 2.871 0 4.307-.437 5.575a8 8 0 0 1-1.848 2.989c-.938.958-2.222 1.6-4.79 2.884l-1.486.743c-2.1 1.05-3.149 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.1-.206-2.15-.73-4.249-1.78l-1.486-.743c-2.568-1.284-3.853-1.926-4.79-2.884a8 8 0 0 1-1.848-2.99c-.437-1.267-.437-2.703-.437-5.574z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits_svg__h)",
    fillOpacity: 0.25,
    d: "M14.048 24.34c0-2.872 0-4.308.437-5.576a8 8 0 0 1 1.847-2.989c.938-.958 2.223-1.6 4.791-2.884l1.486-.743c2.099-1.05 3.148-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.249 1.78l1.485.743c2.569 1.284 3.853 1.926 4.791 2.884a8 8 0 0 1 1.848 2.99c.437 1.267.437 2.703.437 5.574v1.322c0 2.871 0 4.307-.437 5.575a8 8 0 0 1-1.848 2.989c-.938.958-2.222 1.6-4.79 2.884l-1.486.743c-2.1 1.05-3.149 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.1-.206-2.15-.73-4.249-1.78l-1.486-.743c-2.568-1.284-3.853-1.926-4.79-2.884a8 8 0 0 1-1.848-2.99c-.437-1.267-.437-2.703-.437-5.574z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.714,
    d: "M26.924 10.718a7.6 7.6 0 0 1 2.819 0c1.04.195 2.038.69 4.155 1.75l1.485.742c2.592 1.296 3.81 1.91 4.696 2.815a7.65 7.65 0 0 1 1.765 2.855c.413 1.198.417 2.562.417 5.46v1.32c0 2.898-.004 4.262-.417 5.46a7.65 7.65 0 0 1-1.765 2.855c-.886.905-2.104 1.519-4.696 2.815l-1.485.743c-2.117 1.058-3.115 1.554-4.155 1.749a7.6 7.6 0 0 1-2.82 0c-1.04-.195-2.037-.69-4.155-1.75l-1.485-.742c-2.591-1.296-3.809-1.91-4.695-2.815a7.65 7.65 0 0 1-1.766-2.855c-.413-1.198-.417-2.562-.417-5.46v-1.32c0-2.898.004-4.262.417-5.46a7.65 7.65 0 0 1 1.766-2.855c.886-.905 2.104-1.519 4.695-2.815l1.485-.743c2.117-1.058 3.116-1.553 4.156-1.749Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 43.706,
    height: 44.674,
    x: 0.766,
    y: 8.841
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#exploits_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#exploits_svg__j)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exploits_svg__k)",
    d: "M8.333 28.625c0-2.871 0-4.307.437-5.575a8 8 0 0 1 1.848-2.99c.938-.957 2.222-1.6 4.79-2.883l1.487-.743c2.099-1.05 3.148-1.575 4.249-1.781a8 8 0 0 1 2.95 0c1.1.207 2.15.731 4.25 1.78l1.485.744c2.569 1.284 3.853 1.926 4.791 2.884a8 8 0 0 1 1.847 2.99c.438 1.267.438 2.703.438 5.574v1.321c0 2.872 0 4.308-.438 5.576a8 8 0 0 1-1.847 2.989c-.938.958-2.222 1.6-4.791 2.884l-1.486.743c-2.099 1.05-3.148 1.574-4.249 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-1.485-.743c-2.569-1.284-3.853-1.926-4.791-2.884a8 8 0 0 1-1.848-2.99c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.714,
    d: "M21.21 15.004a7.7 7.7 0 0 1 2.819 0c1.04.195 2.038.69 4.155 1.75l1.485.742c2.592 1.296 3.81 1.91 4.695 2.815a7.64 7.64 0 0 1 1.766 2.855c.413 1.198.417 2.562.417 5.46v1.32c0 2.898-.004 4.262-.417 5.46a7.65 7.65 0 0 1-1.766 2.855c-.886.905-2.103 1.519-4.695 2.814l-1.485.744c-2.117 1.058-3.115 1.553-4.155 1.749a7.7 7.7 0 0 1-2.82 0c-1.04-.196-2.038-.69-4.155-1.75l-1.485-.743c-2.592-1.295-3.81-1.91-4.696-2.814a7.65 7.65 0 0 1-1.765-2.855c-.413-1.198-.417-2.562-.417-5.46v-1.32c0-2.898.004-4.262.417-5.46a7.64 7.64 0 0 1 1.765-2.855c.887-.905 2.104-1.519 4.696-2.815l1.485-.743c2.117-1.058 3.115-1.554 4.155-1.749Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exploits_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M21.905 22.857v8.572"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exploits_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M21.905 34.286V35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "exploits_svg__b",
    width: 43.706,
    height: 44.674,
    x: 12.195,
    y: 0.269,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4765",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits_svg__f",
    width: 43.706,
    height: 44.674,
    x: 6.481,
    y: 4.555,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4765",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits_svg__j",
    width: 43.706,
    height: 44.674,
    x: 0.766,
    y: 8.841,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4765",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits_svg__l",
    width: 2.857,
    height: 11.429,
    x: 20.476,
    y: 22.143,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4765"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4765",
    result: "effect2_dropShadow_4384_4765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4765",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exploits_svg__m",
    width: 2.857,
    height: 3.571,
    x: 20.476,
    y: 33.572,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4765"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4765",
    result: "effect2_dropShadow_4384_4765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4765",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exploits_svg__c",
    x1: 34.047,
    x2: 34.047,
    y1: 18.946,
    y2: 36.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exploits_svg__g",
    x1: 28.333,
    x2: 28.333,
    y1: 23.232,
    y2: 40.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exploits_svg__k",
    x1: 23.551,
    x2: 23.551,
    y1: 13.992,
    y2: 61.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "exploits_svg__a",
    transform: "translate(-12.195 -.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.762 20.054c0-2.872 0-4.308.437-5.575a8 8 0 0 1 1.847-2.99c.939-.958 2.223-1.6 4.791-2.884l1.486-.743c2.099-1.05 3.148-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.249 1.78l1.486.743c2.568 1.284 3.852 1.926 4.79 2.884a8 8 0 0 1 1.848 2.99c.437 1.267.437 2.703.437 5.575v1.32c0 2.873 0 4.308-.437 5.576a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-1.486.742c-2.1 1.05-3.149 1.575-4.25 1.781a8 8 0 0 1-2.95 0c-1.1-.206-2.15-.731-4.249-1.78l-1.486-.743c-2.568-1.285-3.852-1.927-4.79-2.885a8 8 0 0 1-1.848-2.989c-.437-1.268-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "exploits_svg__e",
    transform: "translate(-6.48 -4.555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.048 24.34c0-2.872 0-4.308.437-5.576a8 8 0 0 1 1.847-2.989c.938-.958 2.223-1.6 4.791-2.884l1.486-.743c2.099-1.05 3.148-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.1.206 2.15.73 4.249 1.78l1.485.743c2.569 1.284 3.853 1.926 4.791 2.884a8 8 0 0 1 1.848 2.99c.437 1.267.437 2.703.437 5.574v1.322c0 2.871 0 4.307-.437 5.575a8 8 0 0 1-1.848 2.989c-.938.958-2.222 1.6-4.79 2.884l-1.486.743c-2.1 1.05-3.149 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.1-.206-2.15-.73-4.249-1.78l-1.486-.743c-2.568-1.284-3.853-1.926-4.79-2.884a8 8 0 0 1-1.848-2.99c-.437-1.267-.437-2.703-.437-5.574z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "exploits_svg__i",
    transform: "translate(-.766 -8.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.333 28.625c0-2.871 0-4.307.437-5.575a8 8 0 0 1 1.848-2.99c.938-.957 2.222-1.6 4.79-2.883l1.487-.743c2.099-1.05 3.148-1.575 4.249-1.781a8 8 0 0 1 2.95 0c1.1.207 2.15.731 4.25 1.78l1.485.744c2.569 1.284 3.853 1.926 4.791 2.884a8 8 0 0 1 1.847 2.99c.438 1.267.438 2.703.438 5.574v1.321c0 2.872 0 4.308-.438 5.576a8 8 0 0 1-1.847 2.989c-.938.958-2.222 1.6-4.791 2.884l-1.486.743c-2.099 1.05-3.148 1.574-4.249 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-1.485-.743c-2.569-1.284-3.853-1.926-4.791-2.884a8 8 0 0 1-1.848-2.99c-.437-1.267-.437-2.703-.437-5.575z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "exploits_svg__d",
    width: 1.6,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#exploits_svg__n",
    transform: "scale(.00156 .00142)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "exploits_svg__h",
    width: 1.6,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#exploits_svg__n",
    transform: "scale(.00156 .00142)"
  })))));
};
export default SvgExploits;